export class AfterPromise<T = void> {
  private _resolve: undefined | ((arg: T) => void);
  private _reject: undefined | ((error: unknown) => void);

  readonly resolved: Promise<T>;
  get resolve(): (arg: T) => void {
    return this._resolve!;
  }
  get reject(): (error: unknown) => void {
    return this._reject!;
  }

  constructor() {
    this.resolved = new Promise<T>((resolve, reject) => {
      this._resolve = resolve;
      this._reject = reject;
    });
  }
}
